export const skillsData = [
  { name: "Business Strategy", category: "Leadership" },
  { name: "Human Capital Management", category: "Leadership" },
  { name: "Operational Excellence", category: "Leadership" },
  { name: "SAP Implementation", category: "Technical" },
  { name: "Artificial Intelligence", category: "Technical" },
  { name: "Critical Thinking", category: "Core" },
  { name: "New Business Development", category: "Business" },
  { name: "Client Relations", category: "Business" },
  { name: "Coaching & Mentoring", category: "Leadership" },
  { name: "Innovation Management", category: "Leadership" }
];
